















































































































































































































































































































































































































































import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  toRefs,
} from '@vue/composition-api';
import { Message } from 'element-ui';

import SinglePage from '@components/SinglePage';
import request from '@/utils/request';
import {
  dialogObj,
  dialogSubmit,
  tipsDialog,
  closeDialog,
  dialogConfirm,
} from '@/useable/dialog';
import { userInfor as userInfoRef } from '@/useable/login';
import svgCom from '@components/Svg/index';
const userInfor = userInfoRef.value;

export default defineComponent({
  name: 'Role',
  components: { SinglePage, svgCom },
  setup(props, { root }) {
    // 转交角色弹窗
    const roleTransferFormData = reactive({
      workEmail: '', // 邮件
      authName: '', // 授权函文件名
      licenseName: '', // 执照图片文件名
      authUploadStatus: '', // 授权函上传状态
      licenseUploadStatus: '', // 授权函上传状态
      workEmailOptions: [], // 邮箱下拉框
      total: 0, // 总条数
      action: `${process.env.VUE_APP_API_URL}v1/api/suppRegisterFileUpload`, // 文件上传接口地址
      tipShow: true, // 提示框显示
    });
    const roleTransferDialog = reactive({
      showDialog: false,
      title: '管理员转交',
      text: '温馨提示：一旦完成权限转交，您将不再拥有管理员权限，请确保新的管理员已做好接管准备！',
    });
    const statusToText = {
      loading: '上传中',
      finished: '上传成功',
      failed: '上传失败',
    };
    const pageLoading = ref(true);
    const tableLoading = ref(true);
    const ruleForm = ref(null);
    const isCore = ref(userInfor.isCore);
    // 搜索表单配置
    const searchFormOptions = reactive({
      form: {
        name: '',
        cellPhone: '',
        roleName: '',
        roleCode: '',
      },
      formColumn: [
        {
          name: 'name',
          type: 'input',
          label: '员工姓名：',
          disabled: false,
          placeholder: '输入员工姓名',
        },
        {
          name: 'cellPhone',
          type: 'input',
          label: '手机号：',
          placeholder: '输入手机号',
        },
        {
          name: 'roleCode',
          type: 'select',
          label: '角色：',
          placeholder: '',
          options: [
            {
              value: '',
              name: '全部',
            },
          ],
        },
      ],
    });

    // 表格数据初始化
    const tableData = ref([]);
    const columns = ref([
      {
        label: '姓名',
        key: 'name',
      },
      {
        label: '角色',
        key: 'roleName',
        width: 120,
      },
      {
        label: '手机号码',
        key: 'cellPhone',
        width: 140,
      },
      {
        label: '邮箱',
        key: 'workEmail',
        width: 240,
      },
      {
        label: '邀请时间',
        key: 'inviteTime',
        width: 110,
      },
      {
        label: '注册时间',
        key: 'registerTime',
        width: 110,
      },
    ]);

    // 分页数据
    const paginationOptions = reactive({
      size: 10,
      current: 1,
      total: 0,
    });

    const userRole = ref(['sys_user_role']) as any;
    const roleCodeList: any = ref([]);

    // 获取表格数据方法
    const getTableData = async (queryParams) => {
      tableLoading.value = true;
      const res = await request('role', 'getSysUserRole', queryParams);
      if (res?.code === 2000) {
        tableData.value = res.data.records;
        paginationOptions.total = res.data.total;
        paginationOptions.current = res.data.current;
        const temp = res.data.records.filter(item => item.isOperation === 0);
        if (temp.length > 0) {
          userRole.value = temp;
          tableOptions.showEditColumn =
            userRole.value[0].roleCode === 'supplier_administrator' ||
            userRole.value[0].roleCode === 'core_administrator';
        }
        tableLoading.value = false;
      }
    };

    // 数据表格配置
    const tableOptions = reactive({
      tableData,
      columns,
      showSelection: false,
      showEditColumn: true,
      btnsWidth: '230',
      tableLoading,
      getTableData,
      handleSelectionChange: () => {},
    });

    const listCallback = async () => {
      await getTableData(
        Object.assign(searchFormOptions.form, {
          size: paginationOptions.size,
          current: paginationOptions.current,
        }),
      );
    };

    // 获取用户信息
    const getUserData = async () => {
      const res = await request('role', 'getUserRoleCode', {});
      if (res.code === 2000) {
        if (isCore.value) {
          roleCodeList.value = res.data;
        } else {
          roleCodeList.value = res.data.filter(
            i => i.roleName === '普通操作人',
          );
        }
        searchFormOptions.formColumn[2].options =
          searchFormOptions.formColumn[2].options?.concat(
            res.data.map(item => ({
              value: item.roleCode,
              name: item.roleName,
            })),
          );
        await listCallback();
        roleTransferFormData.total = paginationOptions.total;
      }
      pageLoading.value = false;
    };

    const defaultFormData = reactive({
      name: '',
      cellPhone: '',
      workEmail: '',
      roleName: '',
      roleCode: '',
    });
    const dialogFormData = reactive({
      name: '',
      cellPhone: '',
      workEmail: '',
      roleName: '',
      roleCode: '',
      type: 'invitationReq',
      loginName: userInfor.name,
    });

    // 手机号校验
    const validateNum = (rule, value, callback) => {
      const phone =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!phone.test(value) && value) {
        callback(new Error('手机号格式不正确'));
      } else {
        callback();
      }
    };

    const rules = {
      workEmail: [
        { required: true, message: '请选择新管理员', trigger: 'change' },
      ],
      authName: [
        { required: true, message: '请上传授权函', trigger: 'change' },
      ],
      licenseName: [
        { required: true, message: '请上传资质证书', trigger: 'change' },
      ],
    };

    // 增删改
    const onAdd = () => {
      dialogObj.type = 'add';
      dialogObj.title = '新增人员';
      dialogObj.btnText = '发送邀请邮件';
      Object.assign(dialogFormData, defaultFormData);
      dialogObj.state = true;
    };
    const onEdit = (data) => {
      console.log(data);
      dialogObj.type = 'edit';
      dialogObj.title = '编辑人员';
      dialogObj.btnText = '保存';
      Object.assign(dialogFormData, data);
      dialogObj.state = true;
    };
    const onTransfer = async () => {
      roleTransferFormData.workEmail = '';
      roleTransferFormData.authName = '';
      roleTransferFormData.licenseName = '';
      roleTransferFormData.authUploadStatus = ''; // 授权函上传状态
      roleTransferFormData.licenseUploadStatus = ''; // 授权函上传状态
      roleTransferDialog.showDialog = true;
      if (
        roleTransferFormData.workEmailOptions.length === 0 &&
        roleTransferFormData.total
      ) {
        const res = await request('role', 'getSysUserRole', {
          roleCode: 'operator',
          size: roleTransferFormData.total,
          current: 1,
        });
        if (res?.code === 2000) {
          roleTransferFormData.workEmailOptions = res.data.records.map(i => ({
            value: i.workEmail,
            label: `${i.name}(${i.workEmail})`,
          }));
        }
      }
    };
    const onDelete = (data) => {
      dialogObj.type = 'delete';
      Object.assign(dialogFormData, data);
      tipsDialog.text = '确定删除该角色？';
      tipsDialog.icon = 'el-icon-warning';
      tipsDialog.btns = ['cancel', 'delete'];
      tipsDialog.showDialog = true;
    };

    // 模板下载
    const onDownload = async () => {
      await request('login', 'downLoadModel');
    };
    // 上传前校验信息完整
    const isActive = () => {
      if (!roleTransferFormData.workEmail) {
        Message.error('请先选择新管理员，再进行文件上传。');
      }
    };
    /** 文件上传前的钩子 */
    const authBeforeAvatarUpload = (file: any) => {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        Message.error('上传文件大小不能超过 10MB!');
        return false;
      } else {
        roleTransferFormData.authUploadStatus = 'loading';
      }
    };
    /** 文件上传前的钩子 */
    const licenseBeforeAvatarUpload = (file: any) => {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        Message.error('上传文件大小不能超过 10MB!');
        return false;
      } else {
        roleTransferFormData.licenseUploadStatus = 'loading';
      }
    };
    /** 文件上传成功的钩子 */
    const authHandleAvatarSuccess = (res: any) => {
      console.log('>>>>>>>>>>>>上传成功');
      if (res.code === 2000 && res.data) {
        roleTransferFormData.authUploadStatus = 'finished';
        Message.success('上传成功');
        roleTransferFormData.authName = res.data.fileName;
      } else {
        roleTransferFormData.authUploadStatus = 'failed';
        Message.error(res.message);
      }
    };
    /** 文件上传成功的钩子 */
    const licenseHandleAvatarSuccess = (res: any) => {
      console.log('>>>>>>>>>>>>上传成功');
      if (res.code === 2000 && res.data) {
        roleTransferFormData.licenseUploadStatus = 'finished';
        Message.success('上传成功');
        roleTransferFormData.licenseName = res.data.fileName;
      } else {
        roleTransferFormData.licenseUploadStatus = 'failed';
        Message.error(res.message);
      }
    };
    // 转交提交
    const roleTransferConfirm = async () => {
      if (!roleTransferFormData.workEmail) {
        Message.error('请先选择新管理员，再进行文件上传。');
        return;
      }

      if (!roleTransferFormData.authName) {
        Message.error('请上传授权函');
        return;
      }

      if (!roleTransferFormData.licenseName) {
        Message.error('请上传营业执照');
        return;
      }
      const res = await request('role', 'setRoleTransfer', {
        parameter: roleTransferFormData.workEmail,
      });
      if (res?.code === 2000) {
        Message.success('转交申请提交成功');
        roleTransferDialog.showDialog = false;
        getUserData();
      }
    };

    // 修改信用代码或邮箱时清空上传的文件
    const clearFile = () => {
      roleTransferFormData.authName = '';
      roleTransferFormData.licenseName = '';
      roleTransferFormData.authUploadStatus = '';
      roleTransferFormData.licenseUploadStatus = '';
    };

    onMounted(() => {
      getUserData();
    });

    return {
      pageLoading,
      searchFormOptions,
      tableOptions,
      paginationOptions,
      listCallback,
      // 页面数据&方法
      userRole,
      roleCodeList,
      onAdd,
      onEdit,
      onDelete,
      dialogObj,
      closeDialog,
      dialogSubmit,
      dialogConfirm,
      defaultFormData,
      dialogFormData,
      tipsDialog,
      rules,
      ruleForm,
      isCore,
      roleTransferDialog,
      onDownload,
      isActive,
      onTransfer,
      roleTransferFormData,
      userInfor,
      authBeforeAvatarUpload,
      authHandleAvatarSuccess,
      licenseBeforeAvatarUpload,
      licenseHandleAvatarSuccess,
      roleTransferConfirm,
      clearFile,
      statusToText,
    };
  },
});
